import { activity } from '@/locales/en-AU/activity';
import { assistant } from '@/locales/en-AU/assistant';
import { assets } from '@/locales/en-AU/assets';
import { auth } from '@/locales/en-AU/auth';
import { billing } from '@/locales/en-AU/billing';
import { common } from '@/locales/en-AU/common';
import { contacts } from '@/locales/en-AU/contacts';
import { copilot } from '@/locales/en-AU/copilot';
import { home } from '@/locales/en-AU/home';
import { inspections } from '@/locales/en-AU/inspections';
import { jobs } from '@/locales/en-AU/jobs';
import { lifecycleGate } from '@/locales/en-AU/lifecycleGate';
import { navigation } from '@/locales/en-AU/navigation';
import { profile } from '@/locales/en-AU/profile';
import { schedule } from '@/locales/en-AU/schedule';
import { sites } from '@/locales/en-AU/sites';
import { timeline } from '@/locales/en-AU/timeline';
import { work } from '@/locales/en-AU/work';
import { workspace } from '@/locales/en-AU/workspace';
import { enUSResources } from '@/locales/en-US';
import { mergeLocaleResources } from '@/locales/mergeLocaleResources';

export const enAUResources = mergeLocaleResources(enUSResources, {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
} as const);

export type EnAUResources = typeof enAUResources;
